import { Title, Flex, Button } from '@mantine/core';
import { modals } from '@mantine/modals';

import {
  useGetWithdrawalMethods,
  WithdrawalMethodsTable,
  WithdrawalMethodCreateForm,
} from '@/modules/withdrawal-methods';

export const WithdrawalMethods = () => {
  const {
    data,
    isLoading,
  } = useGetWithdrawalMethods();

  const openCreateModal = () => modals.open({
    title: 'Создание метода вывода',
    centered: true,
    children: (
      <WithdrawalMethodCreateForm
        onClose={modals.closeAll}
      />
    ),
  });

  return (
    <>
      <Flex justify="space-between" align="center" w="100%" mb={10}>
        <Title order={4}>Методы вывода</Title>

        <Button
          variant="filled"
          onClick={openCreateModal}
        >
          Создать
        </Button>
      </Flex>

      <WithdrawalMethodsTable
        items={data ?? []}
        isLoading={isLoading}
      />
    </>
  );
};
